import React, { useContext,useEffect } from 'react';
import { useUserAPI } from '../../components/useUserAPI';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import { ShoppingStart } from '../../components/ShoppingStart';
// import { iAeonShowAeonPay } from '../../library/iaeon_sdk.js';
// import { iAeonClose } from '../../library/iaeon_sdk.js';
// import { iAeonShowMemberPay } from '../../library/iaeon_sdk.js';

//お買物API
import { callOkaimonoAPI } from "../../components/okaimonoAPI";

import styles from '../../styles/Regi.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function RegiYujin(props) {


//----------------------------------------
//初期化
//----------------------------------------

const ShoppingStartContext = useContext(ShoppingStart);

useEffect(() => {
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.remove('is_behind');

	props.setRegiType("regi_yujin");

	//高さ調整：arrows We 対応
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('regiFrame');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);


useEffect(() => {
	//お買物API：画面遷移API（支払画面
	props.okaimonoAPI_didScreenTransition("wait_payment");
}, []);


const goKujiLottery = () => {
	props.setPage("kuji_lottery");
	// se08_se();
	props.setSoundState("se08_se");
}
const goKujiList = () => {
	props.setPage("kuji_list");
	// se08_se();
	props.setSoundState("se08_se");
}
const goRegiMeisai = () => {
	props.setPage("regi_meisai");
	// se08_se();
	props.setSoundState("se08_se");
}


//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
// const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);

//会員コード連携バージョン確認：false 5.4.0より小さい 連携なし（暫定版 STEP1）、true 5.4.0以上 連携可能（連携版 STEP2）
// const { memberCodeVerCheck, updateMemberCodeVerCheck } = useContext(SharedInfoContext);


const sharedInfo = useContext(SharedInfoContext);
const { exitGateQR, updateExitGateQR } = useContext(SharedInfoContext);
const { aeonPayFlg, updateAeonPayFlg } = useContext(SharedInfoContext);


// useEffect(() => {

// if(props.otbErrDispState === false){
// 	props.setOtbErrDispState(true);
// 	setTimeout(function(){
// 		if(process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false){ //会員バーコード連携 OTB取得失敗：STEP1 v5.4.0未満
// 			props.setErrFlg(true);
// 			props.setErr([true, "otb_error_step1", ""]);
// 		} else if(process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true){ //会員バーコード連携 OTB取得失敗：STEP2 v5.4.0以上
// 			props.setErrFlg(true);
// 			props.setErr([true, "otb_error_step2", ""]);
// 		}
// 	}, 400);
// }

// }, []);



//----------------------------------------
//お買物API：クーポン・バーコード画面表示API
//----------------------------------------

const okaimonoAPI_tapCouponBarcode = async () => {
	try {
		props.setSoundState("se08_se");

		//お買物API：クーポン・バーコード画面表示API
		console.log("----------------------------");
		console.log("【tapCouponBarcode】call");

		const { callbackId, result } = await callOkaimonoAPI('tapCouponBarcode');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【tapCouponBarcode】success", result);
			console.log("【tapCouponBarcode】result:", result.result);

		}else {
			console.log("【tapCouponBarcode】error", result);
			console.log("【tapCouponBarcode】result:", result.result);
		}

	} catch (error) {
		console.log('【tapCouponBarcode】error', error);
	}
};


return (
	<>
	<div id="regiFrame" className={styles.regiFrame}>

{
	(() => {
		if(ShoppingStartContext.data){
			if (ShoppingStartContext.data.bonusFlag === 1) { //ボーナス有効
				if(props.shoppingData){
					if (props.shoppingData.data) { //SUCCESS

						if(props.shoppingData.data.campaign.bonusAmount === 0){ //売上なし
							return (
								<></>
							)
						}else{ //通常表示
							return (
								<div className={styles.bonus_result}>
									<p className={styles.bonus_result_txt}>
										<span>{props.shoppingData.data.campaign.bonusAmount ? (props.shoppingData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}</span>円引きが適用されました
									</p>
									<span className={styles.bonus_result_img}>
										<img src="/images/kuji/bonus_result.png" alt="" width="390" height="72"/>
									</span>
								</div>
							)
						}

					}else{ //売上なし
						return (
							<></>
						)
					}
				}else{ //売上なし
					return (
						<></>
					)
				}
			}
		}
	})()
}

	<div className={styles.regiBox}>
		{/* <div className={styles.regiBox_regiSenyou} onClick={goRegiSenyouComp}>
			<p className={styles.regiBox_regiSenyou_tit}>レジ番号</p>
			<p className={styles.regiBox_regiSenyou_num}>5</p>
			<p className={styles.regiBox_regiSenyou_txt}>レジの表示を確認し<br/>お会計をしてください</p>
			<div className={styles.regiBox_info}>
				<p className={styles.regiBox_info_label}>点数</p>
				<p className={styles.regiBox_info_num}>12</p>
				<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
			</div>
		</div> */}
		<div className={styles.regiBoxSpace}></div>
		<div className={styles.regiBox_regiSelf}>
			{/* {
				(() => {
					if (props.otbErr !== true){
						if (props.shoppingData.data) { // SUCCESS
							return (
								<div className={styles.regiBox_codeRenkei_label}>
									<div className={`${styles.codeRenkei_circle} ${styles.is_active}`}>
										<span className={styles.codeRenkei_circle01}></span>
									</div>
									<span className={styles.regiBox_codeRenkei_label_txt}>iAEON会員コード認証済</span>
								</div>
							)
						}
					}
				})()
			} */}
			<div className={styles.regiBox_regiSelf_img}>
				<img src="/images/img_regi_self.svg" alt="" width="161" height="159"/>
			</div>
			<p className={styles.regiBox_regiSelf_txt}>レジの表示を確認し<br/>お会計をしてください</p>
			<div className={styles.regiBox_info}>
				<p className={styles.regiBox_info_label}>点数</p>
				<p className={styles.regiBox_info_num}>
				{
					(() => {
						if (props.shoppingData) {
							if (props.shoppingData.data) { // SUCCESS
								return props.shoppingData.data.sumItemCount;
							} else { // ERROR
								return 0;
							}
						} else {
							return 0;
						}
					})()
				}
				</p>
				<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
			</div>
		</div>
	</div>


	<div className={styles.barcodeBox}>
		<p className={styles.barcodeBox_txt}>お支払いを完了する前に<br/>下のボタンをタップしてください
		<small>※AEON Payをご利用の方もこちらから</small></p>
		<div className={styles.barcodeBox_btn} onClick={okaimonoAPI_tapCouponBarcode}>
			<img src="/images/btn_barcode.png" alt="" width="206" height="56" />
		</div>
	</div>


{
	(() => {
		if(ShoppingStartContext.data.lotteryFlag === 1){ //くじ有効
			if(props.shoppingData){
				if (props.shoppingData.data) { //SUCCESS
					if(props.shoppingData.data.campaign.lotteryTimes !== 0){ //くじ回数0でない
						if (props.kujiResult.length === 0) { //くじを引く
							console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
							if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "0"){ //AEONPAY有効＆連携OFF
								console.log("AEONPAY有効 ＆ 連携OFF");
								return (
									<>
									{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}>
										<p className={styles.aeonPayBox_txt}>
											<span>
												<span className={styles.aeonPayBox_txt_icn}>
													<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
												</span>
												AEON Payでお支払いの方はこちら
											</span>
										</p>
										<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
										<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
									</div> */}

									<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

									<div className={styles.kujiBtn} onClick={goKujiLottery}><span className={styles.kujiBtn_in}><span>
										<span className={styles.kujiBtn_in_icn}>
											<img src="/images/icn_kujibtn.svg" alt="" width="29" height="39" />
										</span>
									くじを引く</span></span></div>
									</>
								)
							}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1"){ //AEONPAY有効＆連携ON
								console.log("AEONPAY有効 ＆ 連携ON");
								return (
									<>
									{/* <div className={`${styles.aeonPayBox} ${styles.aeonPayRenkei}`}
									style={{
										display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? "none" : ""
									}}>
										<p className={`${styles.aeonPayBox_txt} ${styles.aeonPayRenkei_txt}`}>
											<span>
												<span className={styles.aeonPayBox_txt_icn}>
													<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
												</span>
												AEON Payでのお支払いは<br/>レジ画面にて選択してください
											</span>
										</p>
									</div> */}

									{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}
									style={{
										display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === false ? "none" : ""
									}}>
										<p className={styles.aeonPayBox_txt}>
											<span>
												<span className={styles.aeonPayBox_txt_icn}>
													<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
												</span>
												AEON Payでお支払いの方はこちら
											</span>
										</p>
										<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
										<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
									</div> */}

									<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

									<div className={styles.kujiBtn} onClick={goKujiLottery}><span className={styles.kujiBtn_in}><span>
										<span className={styles.kujiBtn_in_icn}>
											<img src="/images/icn_kujibtn.svg" alt="" width="29" height="39" />
										</span>
									くじを引く</span></span></div>
									</>
								)
							}else{ //AEONPAY無効
								console.log("AEONPAY無効");
								return (
									<>
									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
										<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
									</div> */}

									<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

									<div className={styles.kujiBtn} onClick={goKujiLottery}><span className={styles.kujiBtn_in}><span>
										<span className={styles.kujiBtn_in_icn}>
											<img src="/images/icn_kujibtn.svg" alt="" width="29" height="39" />
										</span>
									くじを引く</span></span></div>
									</>
								)
							}
						} else { //くじの結果を見る
							console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
							if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "0"){ //AEONPAY有効＆連携OFF
								console.log("AEONPAY有効 ＆ 連携OFF");
								return (
									<>
									{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}>
										<p className={styles.aeonPayBox_txt}>
											<span>
												<span className={styles.aeonPayBox_txt_icn}>
													<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
												</span>
												AEON Payでお支払いの方はこちら
											</span>
										</p>
										<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
										<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
									</div> */}

									<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

									<div className={styles.kujiBtn} onClick={goKujiList}><span className={styles.kujiBtn_in}><span className={styles.is_noicn}>くじの結果を見る</span></span></div>
									</>
								)
							}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1"){ //AEONPAY有効＆連携ON
								console.log("AEONPAY有効 ＆ 連携ON");
								return (
									<>
									{/* <div className={`${styles.aeonPayBox} ${styles.aeonPayRenkei}`}
									style={{
										display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? "none" : ""
									}}>
										<p className={`${styles.aeonPayBox_txt} ${styles.aeonPayRenkei_txt}`}>
											<span>
												<span className={styles.aeonPayBox_txt_icn}>
													<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
												</span>
												AEON Payでのお支払いは<br/>レジ画面にて選択してください
											</span>
										</p>
									</div> */}

									{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}
									style={{
										display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === false ? "none" : ""
									}}>
										<p className={styles.aeonPayBox_txt}>
											<span>
												<span className={styles.aeonPayBox_txt_icn}>
													<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
												</span>
												AEON Payでお支払いの方はこちら
											</span>
										</p>
										<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
										<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
									</div> */}

									<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

									<div className={styles.kujiBtn} onClick={goKujiList}><span className={styles.kujiBtn_in}><span className={styles.is_noicn}>くじの結果を見る</span></span></div>
									</>
								)
							}else{ //AEONPAY無効
								console.log("AEONPAY無効");
								return (
									<>
									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
										<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
									</div> */}

									{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
										<p className={`${styles.menberCodeBox_txt}`}>
											<span>
												<span className={`${styles.menberCodeBox_txt_icn}`}>
													<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
												</span>
												会員コードを登録する方はこちら
											</span>
										</p>
										<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
									</div> */}

									<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

									<div className={styles.kujiBtn} onClick={goKujiList}><span className={styles.kujiBtn_in}><span className={styles.is_noicn}>くじの結果を見る</span></span></div>
									</>
								)
							}
						}
					}else{ //くじ0回
						console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
						if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "0"){ //AEONPAY有効＆連携OFF
							console.log("AEONPAY有効 ＆ 連携OFF");
							return (
								<>
								{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}>
									<p className={styles.aeonPayBox_txt}>
										<span>
											<span className={styles.aeonPayBox_txt_icn}>
												<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
											</span>
											AEON Payでお支払いの方はこちら
										</span>
									</p>
									<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
								</div> */}

								{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
									<p className={`${styles.menberCodeBox_txt}`}>
										<span>
											<span className={`${styles.menberCodeBox_txt_icn}`}>
												<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
											</span>
											会員コードを登録する方はこちら
										</span>
									</p>
									<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
									<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
								</div> */}

								{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
									<p className={`${styles.menberCodeBox_txt}`}>
										<span>
											<span className={`${styles.menberCodeBox_txt_icn}`}>
												<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
											</span>
											会員コードを登録する方はこちら
										</span>
									</p>
									<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
								</div> */}

								<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
								</>
							)
						}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1"){ //AEONPAY有効＆連携ON
							console.log("AEONPAY有効 ＆ 連携ON");
							return (
								<>
								{/* <div className={`${styles.aeonPayBox} ${styles.aeonPayRenkei}`}
								style={{
									display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? "none" : ""
								}}>
									<p className={`${styles.aeonPayBox_txt} ${styles.aeonPayRenkei_txt}`}>
										<span>
											<span className={styles.aeonPayBox_txt_icn}>
												<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
											</span>
											AEON Payでのお支払いは<br/>レジ画面にて選択してください
										</span>
									</p>
								</div> */}

								{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}
								style={{
									display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === false ? "none" : ""
								}}>
									<p className={styles.aeonPayBox_txt}>
										<span>
											<span className={styles.aeonPayBox_txt_icn}>
												<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
											</span>
											AEON Payでお支払いの方はこちら
										</span>
									</p>
									<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
								</div> */}

								{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
									<p className={`${styles.menberCodeBox_txt}`}>
										<span>
											<span className={`${styles.menberCodeBox_txt_icn}`}>
												<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
											</span>
											会員コードを登録する方はこちら
										</span>
									</p>
									<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
									<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
								</div> */}

								{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
									<p className={`${styles.menberCodeBox_txt}`}>
										<span>
											<span className={`${styles.menberCodeBox_txt_icn}`}>
												<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
											</span>
											会員コードを登録する方はこちら
										</span>
									</p>
									<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
								</div> */}

								<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
								</>
							)
						}else { //AEONPAY無効
							console.log("AEONPAY無効");
							return (
								<>
								{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
									<p className={`${styles.menberCodeBox_txt}`}>
										<span>
											<span className={`${styles.menberCodeBox_txt_icn}`}>
												<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
											</span>
											会員コードを登録する方はこちら
										</span>
									</p>
									<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
									<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
								</div> */}

								{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
									<p className={`${styles.menberCodeBox_txt}`}>
										<span>
											<span className={`${styles.menberCodeBox_txt_icn}`}>
												<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
											</span>
											会員コードを登録する方はこちら
										</span>
									</p>
									<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
								</div> */}

								<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
								</>
							)
						}
					}
				}
			}else{
				console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
				if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "0"){ //AEONPAY有効＆連携OFF
					console.log("AEONPAY有効 ＆ 連携OFF");
					return (
						<>
						{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}>
							<p className={styles.aeonPayBox_txt}>
								<span>
									<span className={styles.aeonPayBox_txt_icn}>
										<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
									</span>
									AEON Payでお支払いの方はこちら
								</span>
							</p>
							<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
						</div> */}

						{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
							<p className={`${styles.menberCodeBox_txt}`}>
								<span>
									<span className={`${styles.menberCodeBox_txt_icn}`}>
										<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
									</span>
									会員コードを登録する方はこちら
								</span>
							</p>
							<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
							<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
						</div> */}

						{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
							<p className={`${styles.menberCodeBox_txt}`}>
								<span>
									<span className={`${styles.menberCodeBox_txt_icn}`}>
										<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
									</span>
									会員コードを登録する方はこちら
								</span>
							</p>
							<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
						</div> */}

						<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
						</>
					)
				}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1"){ //AEONPAY有効＆連携ON
					console.log("AEONPAY有効 ＆ 連携ON");
					return (
						<>
						{/* <div className={`${styles.aeonPayBox} ${styles.aeonPayRenkei}`}
						style={{
							display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? "none" : ""
						}}>
							<p className={`${styles.aeonPayBox_txt} ${styles.aeonPayRenkei_txt}`}>
								<span>
									<span className={styles.aeonPayBox_txt_icn}>
										<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
									</span>
									AEON Payでのお支払いは<br/>レジ画面にて選択してください
								</span>
							</p>
						</div> */}

						{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}
						style={{
							display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === false ? "none" : ""
						}}>
							<p className={styles.aeonPayBox_txt}>
								<span>
									<span className={styles.aeonPayBox_txt_icn}>
										<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
									</span>
									AEON Payでお支払いの方はこちら
								</span>
							</p>
							<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
						</div> */}

						{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
							<p className={`${styles.menberCodeBox_txt}`}>
								<span>
									<span className={`${styles.menberCodeBox_txt_icn}`}>
										<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
									</span>
									会員コードを登録する方はこちら
								</span>
							</p>
							<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
							<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
						</div> */}

						{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
							<p className={`${styles.menberCodeBox_txt}`}>
								<span>
									<span className={`${styles.menberCodeBox_txt_icn}`}>
										<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
									</span>
									会員コードを登録する方はこちら
								</span>
							</p>
							<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
						</div> */}

						<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
						</>
					)
				}else { //AEONPAY無効
					console.log("AEONPAY無効");
					return (
						<>
						{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
							<p className={`${styles.menberCodeBox_txt}`}>
								<span>
									<span className={`${styles.menberCodeBox_txt_icn}`}>
										<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
									</span>
									会員コードを登録する方はこちら
								</span>
							</p>
							<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
							<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
						</div> */}

						{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
							<p className={`${styles.menberCodeBox_txt}`}>
								<span>
									<span className={`${styles.menberCodeBox_txt_icn}`}>
										<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
									</span>
									会員コードを登録する方はこちら
								</span>
							</p>
							<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
						</div> */}

						<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
						</>
					)
				}
			}
		}else{ //くじ無効
			console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
			if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "0"){ //AEONPAY有効＆連携OFF
				console.log("AEONPAY有効 ＆ 連携OFF");
				return (
					<>
					{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}>
						<p className={styles.aeonPayBox_txt}>
							<span>
								<span className={styles.aeonPayBox_txt_icn}>
									<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
								</span>
								AEON Payでお支払いの方はこちら
							</span>
						</p>
						<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
					</div> */}

					{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
						<p className={`${styles.menberCodeBox_txt}`}>
							<span>
								<span className={`${styles.menberCodeBox_txt_icn}`}>
									<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
								</span>
								会員コードを登録する方はこちら
							</span>
						</p>
						<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
						<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
					</div> */}

					{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
						<p className={`${styles.menberCodeBox_txt}`}>
							<span>
								<span className={`${styles.menberCodeBox_txt_icn}`}>
									<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
								</span>
								会員コードを登録する方はこちら
							</span>
						</p>
						<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
					</div> */}

					<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
					</>
				)
			}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1"){ //AEONPAY有効＆連携ON
				console.log("AEONPAY有効 ＆ 連携ON");
				return (
					<>
					{/* <div className={`${styles.aeonPayBox} ${styles.aeonPayRenkei}`}
					style={{
						display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? "none" : ""
					}}>
						<p className={`${styles.aeonPayBox_txt} ${styles.aeonPayRenkei_txt}`}>
							<span>
								<span className={styles.aeonPayBox_txt_icn}>
									<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
								</span>
								AEON Payでのお支払いは<br/>レジ画面にて選択してください
							</span>
						</p>
					</div> */}

					{/* <div className={`${styles.aeonPayBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true ? '' : styles.is_last}`}
					style={{
						display: process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === false ? "none" : ""
					}}>
						<p className={styles.aeonPayBox_txt}>
							<span>
								<span className={styles.aeonPayBox_txt_icn}>
									<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
								</span>
								AEON Payでお支払いの方はこちら
							</span>
						</p>
						<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
					</div> */}

					{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
						<p className={`${styles.menberCodeBox_txt}`}>
							<span>
								<span className={`${styles.menberCodeBox_txt_icn}`}>
									<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
								</span>
								会員コードを登録する方はこちら
							</span>
						</p>
						<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
						<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
					</div> */}

					{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
						<p className={`${styles.menberCodeBox_txt}`}>
							<span>
								<span className={`${styles.menberCodeBox_txt_icn}`}>
									<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
								</span>
								会員コードを登録する方はこちら
							</span>
						</p>
						<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
					</div> */}

					<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
					</>
				)
			}else { //AEONPAY無効
				console.log("AEONPAY無効");
				return (
					<>
					{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false ? '' : styles.is_hide}`}>
						<p className={`${styles.menberCodeBox_txt}`}>
							<span>
								<span className={`${styles.menberCodeBox_txt_icn}`}>
									<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
								</span>
								会員コードを登録する方はこちら
							</span>
						</p>
						<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
						<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
					</div> */}

					{/* <div className={`${styles.menberCodeBox} ${process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true ? '' : styles.is_hide}`}>
						<p className={`${styles.menberCodeBox_txt}`}>
							<span>
								<span className={`${styles.menberCodeBox_txt_icn}`}>
									<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
								</span>
								会員コードを登録する方はこちら
							</span>
						</p>
						<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
					</div> */}

					<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>
					</>
				)
			}
		}
	})()
}

	</div>

	</>
)

}
